import { render, staticRenderFns } from "./ButtonModal.vue?vue&type=template&id=2c5b12c8"
import script from "./ButtonModal.vue?vue&type=script&lang=js"
export * from "./ButtonModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports